import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import { ElementDetailsAction } from "models/Resources/ElementDetailsResource";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

type Props = {
  isOpen: boolean;
  elementAction: ElementDetailsAction;
  onActionConfirm: (isConfirmed: boolean) => void;
};

const ConfirmAction: React.FC<Props> = ({
  isOpen,
  elementAction,
  onActionConfirm,
}) => {
  const [isDialogOpen, setOpen] = useState(isOpen);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={isDialogOpen}
      className="dialog-window"
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            minWidth: "600px",
            minHeight: "250px",
          },
        },
      }}>
      <DialogTitle id="confirm-action-title">
        {"Confirmation"}
        <IconButton
          id="dialog-close-btn"
          aria-label="close"
          onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        className="dialog-body"
        style={{
          padding: "45px",
          borderStyle: "hidden",
        }}>
        <CheckCircleOutlineIcon
          className="check-icon"
          fontSize="large"
          sx={{
            fontSize: 60,
          }}
        />
        <Stack>{`Êtes-vous certain de vouloir effectuer cette action "${elementAction.etiquette}"?`}</Stack>
      </DialogContent>

      <DialogActions style={{ justifyContent: "center" }}>
        <Button
          autoFocus
          className="dialog-buttons"
          style={{
            backgroundColor: "white",
            color: "black",
            width: "35%",
          }}
          variant="outlined"
          onClick={() => onActionConfirm(false)}>
          {"Annuler"}
        </Button>
        <Button
          autoFocus
          className="dialog-buttons"
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            width: "35%",
          }}
          variant="contained"
          onClick={() => onActionConfirm(true)}>
          {"Confirmer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmAction;
